import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { usePageContext } from '@hero/web-context';
import { PricingSheetPage } from '@hero/web-components';

/**
 * Standalone org-wide pricing surface mounted under `/more/pricing`.
 *
 * Uses the same `PricingSheetPage` as the per-client workspace tab,
 * but seeded with the `'own'` scope (the carrier's open price list)
 * and with the scope picker enabled so the user can pivot to a
 * specific customer or agreement on demand.
 */
export default function PricingPage() {
  const { t } = useTranslation(['m-pricing']);
  const { setPageName } = usePageContext();

  useEffect(() => {
    setPageName(t('header.title', { defaultValue: 'Pricing' }));
  }, [setPageName, t]);

  return (
    <PricingSheetPage initialScope={{ kind: 'own' }} redirect />
  );
}
